import React from 'react';

import { SanityGlobalProduct } from '@rsc/models/gatsby-graphql-types';
import { useUiComponentsInternationalContext } from '@rsc/static-translations';

interface Props {
  pricing: {
    compareAtPrice?: number;
    percentageDiscount?: number;
    price: number;
    priceRange: string;
    unSubPrice?: number;
  };
  product: SanityGlobalProduct;
  subscribed?: boolean;
}

const Price = ({ pricing, product, subscribed }: Readonly<Props>) => {
  const { tt, localizePrice } = useUiComponentsInternationalContext();

  const getDisplayPrice = () => {
    // if there is no active variant, return the display price range
    if (!pricing?.price) {
      const min = product?.shopifyProduct?.priceRangeV2?.minVariantPrice.amount;

      const max = product?.shopifyProduct?.priceRangeV2?.maxVariantPrice.amount;

      const range =
        min === max
          ? localizePrice(Number(min))
          : `${localizePrice(Number(min))} - ${localizePrice(Number(max))}`;

      return (
        <span className="text-2xl font-bold text-foreground md:text-4xl">
          {range}
        </span>
      );
    }

    return (
      <div className="flex flex-col">
        <span className="text-2xl font-bold text-foreground md:text-4xl">
          {localizePrice(pricing?.price)}
        </span>
        {/* if there is a sale price, return the sale price component */}
        {(!!pricing?.compareAtPrice || subscribed) && (
          <div className="flex items-center gap-1">
            <span className="text-xl font-light text-destructive line-through">
              {localizePrice(
                pricing?.compareAtPrice
                  ? pricing.compareAtPrice
                  : pricing?.unSubPrice
              )}
            </span>
            <span className="text-xl font-light text-destructive">
              (
              {tt(s => s.priceComponent.savingsLabel, {
                percentageDiscount: pricing.percentageDiscount.toString(),
              })}
              )
            </span>
          </div>
        )}
      </div>
    );
  };

  return <div>{getDisplayPrice()}</div>;
};

export default Price;
